<div class="rain">
  <svg-icon
    class="rain-background"
    src="assets/images/ui-effects/background-vector-left-yellow.svg"
  ></svg-icon>
  <svg-icon
    class="rain-icon flex items-center justify-center s-24"
    [svgStyle]="{ 'width.px': 24, 'height.px': 24 }"
    src="assets/icons/features/rain.svg"
  ></svg-icon>
  <div class="rain-name">Rain</div>
  <div class="rain-info">
    <svg-icon src="assets/icons/core/skins.svg" />{{ rain().amount | number: "1.2-2" }}
    <span class="separator"></span>
    <countdown
      #cd
      class="countdown"
      [config]="{ stopTime: rain().timer * 1000, format: 'mm:ss' }"
    />
  </div>
  @if (rain().state === 1 || rain().state === 2) {
  <button
    @fadeInAnimation
    type="button"
    (click)="openTipRainModal()"
    class="rain-tip button button--style-blue h-32 rounded-4 padding-x-12"
  >
    Tip
  </button>
  @if (rain().state === 2) {
  <button
    @fadeInAnimation
    type="button"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    (click)="openCaptchaJoin()"
    class="rain-join button button--style-yellow h-32 rounded-4 padding-x-12"
  >
    Join
  </button>

  @if (rain().captcha) {
  <ng-template
    cdkConnectedOverlay
    [cdkConnectedOverlayOrigin]="trigger"
    [cdkConnectedOverlayOpen]="isCaptchaOverlay"
    (detach)="isCaptchaOverlay = false"
    cdkConnectedOverlayPanelClass="context-menu-panel"
  >
    <app-captcha-overlay
      [captcha]="rain().captcha!"
      (closeCaptchaOverlay)="isCaptchaOverlay = false"
      (verifyCaptcha)="handleVerifyCaptcha($event)"
    ></app-captcha-overlay>
  </ng-template>
  } } }
</div>
